import { render, staticRenderFns } from "./new_quote.vue?vue&type=template&id=8cdf6046&scoped=true"
import script from "./new_quote.vue?vue&type=script&lang=js"
export * from "./new_quote.vue?vue&type=script&lang=js"
import style0 from "./new_quote.vue?vue&type=style&index=0&id=8cdf6046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdf6046",
  null
  
)

export default component.exports